import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import ComboBoxProps from './ComboBoxProps'

import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    render(createElement) {
        return createElement('input', [
            this.$slots['kendo-datasource']
        ])
    },
    props: ComboBoxProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el

        kendo.jQuery(widgetElement).kendoComboBox(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', widgetElement.value)
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoComboBox()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoComboBox/KendoComboBoxMixin.js